<p>
  {{
    'sharedModule.bkgVehicleDialogLicensePlate.insertCarLicensePlate'
      | translate
  }}
</p>
<form class="form-group" [formGroup]="newVehiclePlateForm">
  <div class="input-plate">
    <input
      formControlName="plate"
      type="text"
      id="plate"
      class="form-item"
      name=""
      placeholder=" {{
        'sharedModule.bkgVehicleDialogLicensePlate.placeholderPlate' | translate
      }}"
      autocomplete="off"
      [attr.disabled]="addMoreInfoLicense ? true : null"
    />
  </div>
</form>

<p *ngIf="!addMoreInfoLicense">
  <a class="link" (click)="onForgottenCarLicense()">
    {{
      'sharedModule.bkgVehicleDialogLicensePlate.forgottenCarLicensePlate'
        | translate
    }}</a
  >
</p>

<button
  *ngIf="!addMoreInfoLicense"
  class="btn-primary btn-large is-block"
  [disabled]="newVehiclePlateForm.invalid || formSending"
  (click)="submitNewVehiclePlate()"
>
  {{ 'sharedModule.bkgVehicleDialogLicensePlate.agree' | translate }}
</button>
